import React, { ReactNode, useEffect } from "react";
import { navigate } from "gatsby";
import Header from "./Header";
import Footer from "./Footer";
import { AuthProvider, useAuth } from "../contexts/AuthContext";

interface AdminLayoutProps {
  children: ReactNode;
}

// This component checks if the user is authenticated and redirects to login if not
const ProtectedRoute: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Only use auth in browser context to prevent SSG errors
  const isBrowser = typeof window !== 'undefined';
  const auth = isBrowser ? useAuth() : { isAuthenticated: false, loading: true };
  const { isAuthenticated, loading } = auth;

  useEffect(() => {
    // Only run this effect in the browser
    if (isBrowser && !loading && !isAuthenticated) {
      navigate("/login");
    }
  }, [isBrowser, isAuthenticated, loading]);

  if (loading) {
    return <div className="p-8 text-center">Loading...</div>;
  }

  return isAuthenticated ? <>{children}</> : null;
};

// The AdminLayout wraps content with AuthProvider and ProtectedRoute
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <AuthProvider>
      <div className="flex flex-col min-h-screen">
        <main className="flex-grow">
          <ProtectedRoute>{children}</ProtectedRoute>
        </main>
      </div>
    </AuthProvider>
  );
};

export default AdminLayout;
